import { NgOptimizedImage } from '@angular/common';
import { Component, OnDestroy, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../../services/navigation.service';

@Component({
  selector: 'app-image-preview',
  imports: [NgOptimizedImage],
  template: `
    <div
      class="fixed top-0 left-0 bottom-0 right-0 z-[100] duration-200 transition-all ease-in-out"
      [class.opacity-0]="!imagePrev()"
      [class.opacity-100]="imagePrev()"
      [class.z-[100]]="imagePrev()"
      [class.z-[-1]]="!imagePrev()"
      (click)="loc.goBack('/')"
    >
      <div
        class="absolute top-0 left-0 right-0 bottom-0 bg-light"
      ></div>
      <div class="h-full w-full flex flex-col">
        <div class="flex-1 w-full relative items-center justify-center">
          <!--
            Guarded: this component lives in the layout, so it renders on every
            page with an empty imagePrev() until someone opens a preview.
            NgOptimizedImage throws NG02952 on an empty ngSrc, which fired on
            every SSR render and every prerendered route. The overlay is hidden
            anyway when there is no image, so there is nothing to show here.
          -->
          @if (imagePrev()) {
            <img
              [ngSrc]="imagePrev()"
              class="w-full h-full object-contain py-4"
              alt="Enlarged image preview"
              fill
            />
          }
        </div>
        <div class="flex-shrink-0 relative">
          <button
            class="bg-danger text-dangerContrast w-full text-center px-4 py-2"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class ImagePreviewComponent implements OnDestroy {
  subs = new Subscription();
  imagePrev = signal<string>('');

  constructor(private route: ActivatedRoute, public loc: NavigationService) {
    this.subs.add(
      this.route.queryParams.subscribe((params) => {
        const imagePrev = params['imagePreview'];
        this.imagePrev.set(imagePrev ?? '');
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
